<template>
  <div id="addclient">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="clientinfo_work">
        <div class="clientinfo_work_item">
            <span>备注名称</span>
            <input type="text" placeholder="名称" v-model="name">
        </div>
        <div class="clientinfo_work_item">
            <span>对方账户</span>
            <input type="text" placeholder="用户名/手机号" v-model="phone">
        </div>
    </div>
    <div class="client_add">
      <button @click="submitInfo">保存</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientMess',
  data () {
    return {
      name: '',
      phone: '',
      id: 0,
      oldName: '',
      oldPhone: ''
    }
  },
  methods: {
    /* 返回上一层 */
    back () {
      this.$router.push({
        path: '/clientlist'
      })
    },
    /* 提交用户信息 */
    submitClientInfo () {
      this.axios.post('/ApiLinkMan/UpdateLinkMan', {
        ManName: this.name,
        ManAct: this.phone,
        ID: this.id
      })
        .then(this.submitClientInfoSucc)
        .catch(this.submitClientInfoFail)
    },
    submitClientInfoSucc (res) {
      res = res.data || {}
      if (res.errorInfo === '') {
        this.$router.push({
          path: '/clientlist'
        })
      } else {
        alert(res.errorInfo)
      }
    },
    submitClientInfoFail (err) {
      alert(err)
    },
    submitInfo () {
      if (this.name === '' || this.phone === '') {
        alert('请填写信息')
        return
      }
      if (this.phone === this.oldPhone && this.name === this.oldName) {
        return
      }
      this.submitClientInfo()
    }
  },
  mounted () {
    let clientInfo = this.$route.query.clientInfo || {}
    this.phone = clientInfo.account || ''
    this.name = clientInfo.name || ''
    this.id = clientInfo.id
    this.oldName = this.name
    this.oldPhone = this.phone
  }
}
</script>

<style scoped>
#addclient{min-height: 100%;}
.header{display: flex;justify-content: space-between;align-items: center;padding: 10px 15px;}
.header a{text-decoration: none;color: #333;}
.header .iconfont{font-size: 25px;}
.clientinfo_work{padding: 10px;border-top: 10px solid #f2f2f2;}
.client_add{margin: 30px 0;}
.client_add button{width: 80%; margin-right: auto;margin-left: auto;background-color: #ed2727;color: #fff;display: block;border: 0;height: 33px;border-radius: 3px;font-size: 14px}
.clientinfo_work_item{padding: 10px 0;}
.clientinfo_work_item input{margin-left: 20px;}
</style>



// WEBPACK FOOTER //
// src/pages/editclient/components/Mess.vue